
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceMenuResource,
} from '../models';
import {
    ComplianceMenuResourceFromJSON,
    ComplianceMenuResourceToJSON,
} from '../models';

export interface GetMenuRequest {
    companyId?: string;
}

/**
 * 
 */
export class ComplianceMenuApi extends runtime.BaseAPI {

    /**
          */
    async getMenuRaw(requestParameters: GetMenuRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComplianceMenuResource>> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ComplianceMenuResource>({
            path: `/compliance/api/step`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ComplianceMenuResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getMenu(requestParameters: GetMenuRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComplianceMenuResource> {
        const response = await this.getMenuRaw(requestParameters, initOverrides);
        return response._data;
    }

}
